<template>
  <div>
    <v-navigation-drawer
      v-model="isOpen"
      :width="$isMobile ? '100%' : '60%'"
      right
      fixed
      :permanent="isOpen"
      hide-overlay
      class="z-index--100 pl-4"
      style="overflow: visible;">
      <div class="pa-3 content" style="overflow: auto; height: 100vh;">
        <div v-if="isOpen" class="d-flex">
          <v-btn
            dark
            fab
            small
            outlined
            color="primary"
            class="close mr-3"
            @click="closePanel"
            style="position: absolute; left: -20px; background-color: #fff; z-index: 100;"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>
        <div class="d-flex mt-6">
          <div class="titlePanel primary--text">
            {{ $t('expenses.bankReconciliation.transactions.relatePanel.title') }}
          </div>

        </div>
          <!-- <div class="subtitle">
            {{ $t('expenses.bankReconciliation.transactions.relatePanel.tableMovements.title') }}
          </div>
          <div v-if="tableMovements.data.length">
            <v-data-table
              v-model="tableMovements.selected"
              :loading-text="tableMovements.title"
              :loading="tableMovements.loading"
              :headers="tableMovements.headers"
              :items="tableMovements.data"
              :options="tableMovements.options"
              show-select
              item-key="_id"
              hide-default-footer
              class="relateTable"
              sort-by="date">
              <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
                <v-simple-checkbox
                  :ripple="false"
                  :value="isSelected"
                  @input="select($event)"
                  :style="{ color: isSelected ? 'var(--v-primary-base) !important' : '' }"
                ></v-simple-checkbox>
              </template>
              <template v-slot:[`item._id`]="{ item }">
                <div>
                  {{ item._id }}
                </div>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                <div>
                  {{ $moment(item.date).format('DD/MM/YYYY') }}
                </div>
              </template>
              <template v-slot:[`item.beneficiary`]="{ item }">
                <div>
                  {{ item.beneficiary }}
                </div>
              </template>
              <template v-slot:[`item.concept`]="{ item }">
                <div>
                  {{ item.concept }}
                </div>
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                <div>
                  ${{ item.amount | toFix2 | numberWithComma }}
                </div>
              </template>
            </v-data-table>
          </div> -->
          <!-- <div v-else class="noInfo">
            {{ $t('expenses.bankReconciliation.transactions.relatePanel.noInfo') }}
          </div> -->
          <div class="subtitle">
            {{ $t('expenses.bankReconciliation.transactions.relatePanel.tableOrders.title') }}
          </div>
          <div v-if="tableOrders.data.length">
            <v-data-table
              v-model="tableOrders.selected"
              :loading-text="tableOrders.title"
              :loading="tableOrders.loading"
              :headers="tableOrders.headers"
              :items="tableOrders.data"
              :options="tableOrders.options"
              show-select
              item-key="_id"
              class="relateTable"
              :footer-props="{
                'items-per-page-options': [5, 10, 15]
              }"
              sort-by="date">
              <template v-slot:top>
                <div class="px-3 filters">
                  <v-row>
                    <v-col
                      cols="12"
                      md="3">
                      <v-text-field
                        v-model="searchProvider.search"
                        append-icon="mdi-magnify"
                        label="Busca nombre del proveedor"
                        hide-details
                        rounded
                        outlined
                        color="primary"
                        />
                    </v-col>
                  </v-row>
                </div>
              </template>
              <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
                <v-simple-checkbox
                  :ripple="false"
                  :value="isSelected"
                  @input="select($event)"
                  :style="{ color: isSelected ? 'var(--v-primary-base) !important' : '' }"
                ></v-simple-checkbox>
              </template>
              <template v-slot:[`item.id`]="{ item }">
                <div>
                  {{ item.id }}
                </div>
              </template>
              <template v-slot:[`item.invoice`]="{ item }">
                <v-btn
                  class="mr-3"
                  fab
                  color="info"
                  x-small
                  depressed
                  @click="openDetail(item.invoice)">
                  <v-icon>
                    mdi-receipt
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                <div>
                  {{ $moment(item.date).format('DD/MM/YYYY') }}
                </div>
              </template>
              <template v-slot:[`item.paymentMethod`]="{ item }">
                <div>
                  {{ item.paymentMethod }}
                </div>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <div>
                  {{ statusNames(item.status) }}
                </div>
              </template>
              <template v-slot:[`item.total`]="{ item }">
                <div>
                  ${{ item.total | toFix2 | numberWithComma }}
                </div>
              </template>
              <template v-slot:[`item.provider`]="{ item }">
                <div>
                  {{ item.invoice ? item.invoice.source : '-' }}
                </div>
              </template>
              <template v-slot:[`item.receiver`]="{ item }">
                <div>
                  {{ item.receiver || '-' }}
                </div>
              </template>
            </v-data-table>
          </div>
          <div v-else class="noInfo">
            {{ $t('expenses.bankReconciliation.transactions.relatePanel.noInfo') }}
          </div>
          <div class="grow"></div>
          <div class="d-flex justify-space-between buttonContainer">
            <div class="mx-3" v-if="movementsPermissions['create-pay-order']">
              <v-btn
                color="primary"
                depressed
                @click="openAddPayOrderPanel"
              >
                Generar documento como anticipo
              </v-btn>
            </div>
            <div class="mx-1" v-if="buttonRelateCategory">
              <v-btn
                color="secondary"
                depressed
                @click="openRelateCategory"
              >
                Relacionar a una categoría
              </v-btn>
            </div>
            <v-spacer />
            <Button
              v-if="buttonRelateMovement"
              size="large"
              :disabled="(!tableMovements.selected.length && !tableOrders.selected.length) || (tableMovements.data.length === 0 && tableOrders.data.length === 0)"
              @click="checkAmountsCoincide()">
              {{ $t('expenses.bankReconciliation.transactions.relatePanel.button') }}
            </Button>
          </div>
      </div>
    </v-navigation-drawer>

    <InvoiceViewer ref="invoiceViewer" />

    <v-dialog @keydown.esc="warningDialogOpen=false" v-model="warningDialogOpen" persistent max-width="453px">
      <v-card>
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            depressed
            @click="closeWarningDialog()"
            class="mr-1 mt-1"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="d-flex flex-column align-center">
          <v-icon class="alert-icon">mdi-alert-circle-outline</v-icon>
          <div class="mt-4 text-center">
            <p class="dialogText">{{ $t('expenses.bankReconciliation.transactions.relatePanel.warningDialog.text') }}</p>
          </div>
          <div class="mt-2 d-flex invoiceBox">
            <table>
              <tr>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <td class="font-weight-bold">{{ $t('expenses.bankReconciliation.transactions.relatePanel.warningDialog.transactionsAmount') }}</td>
                <td>{{ totalInvoicesAmount | toFix2 | numberWithComma | prefix('$') }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">{{ $t('expenses.bankReconciliation.transactions.relatePanel.warningDialog.ordersAndMovementsAmount') }}</td>
                <td>{{ totalMovementsOrdersAmount | toFix2 | numberWithComma | prefix('$') }}</td>
              </tr>
            </table>
          </div>
        </v-card-text>
        <v-card-actions class="px-6 justify-space-between">
          <Button size="small" type="outlined" @click="closeWarningDialog()">
            {{ $t('expenses.bankReconciliation.transactions.relatePanel.warningDialog.buttonCancel') }}
          </Button>
          <Button size="small" @click="relateBankMovement()" v-if="movementsPermissions['relate-pay-order']">
            {{ $t('expenses.bankReconciliation.transactions.relatePanel.warningDialog.buttonConfirm') }}
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="relateCategoryOpen=false" max-width="410px" v-model="relateCategoryOpen">
      <v-card>
        <v-card-title>
          <div class="d-flex">
            <div class="primary--text">
              Relacionar categoría
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="mb-2">Seleccione la categoría que desea relacionar al movimiento bancario.</div>
          <v-form v-model="isValid" ref="accountForm">
            <v-row>
              <v-col class="py-0" cols="12">
                <v-select
                  rounded
                  outlined
                  dense
                  item-text="name"
                  item-value="_id"
                  :items="categories.data"
                  v-model="categoryForm.outgoingCategory"
                  :rules="rules.required"
                  label="Categorías de egreso"
                  required
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="closeRelateCategory">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            small
            depressed
            @click="relateCategory()">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddPayOrder
      :isOpen.sync="isAddPayOrderPanelOpen"
      :transactions="transactions || []"
      @updatePayOrders="emitUpdateBankReconciliation()"
      @reset="resetSelectedTransactions"
    />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Button from '@/components/elements/Button'
import InvoiceViewer from '@/components/modals/InvoiceViewer'
import sumBy from 'lodash/sumBy'
import AddPayOrder from '@/components/sidePanels/AddPayOrder'
import { debounce } from 'lodash'

export default {
  name: 'RelateBankMovements',
  props: {
    isOpen: Boolean,
    buttonRelateMovement: Boolean,
    buttonRelateCategory: Boolean,
    transactions: Object || Array,
    bankId: String,
    accountId: String
  },
  components: {
    AddPayOrder,
    Button,
    InvoiceViewer
  },
  emits: ['updateTransactions', 'close'],
  data () {
    return {
      isAddPayOrderPanelOpen: false,
      relateCategoryOpen: false,
      overlay: false,
      tableMovements: {
        title: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableMovements.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableMovements.headers.id'), value: '_id', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableMovements.headers.date'), value: 'date', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableMovements.headers.author'), value: 'beneficiary', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableMovements.headers.concept'), value: 'concept', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableMovements.headers.amount'), value: 'amount', sortable: false }
        ],
        data: [],
        total: 0,
        itemsPerPage: 10,
        page: 1,
        selected: []
      },
      tableOrders: {
        title: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableOrders.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableOrders.headers.id'), value: 'id', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableOrders.headers.date'), value: 'date', sortable: false },
          // { text: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableOrders.headers.paymentMethod'), value: 'paymentMethod', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableOrders.headers.status'), value: 'status', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableOrders.headers.amount'), value: 'total', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableOrders.headers.invoice'), value: 'invoice', sortable: false },
          { text: this.$i18n.t('expenses.bankReconciliation.transactions.relatePanel.tableOrders.headers.supplier'), value: 'provider', sortable: false }
        ],
        data: [],
        total: 0,
        itemsPerPage: 10,
        page: 1,
        selected: []
      },
      warningDialogOpen: false,
      searchProvider: {
        search: '',
        selected: null,
        items: [],
        isLoading: false
      },
      categories: {
        data: [],
        loading: true
      },
      categoryForm: {
        outgoingCategory: null
      },
      rules: {
        required: [v => !!v || 'Required']
      }
    }
  },
  watch: {
    open: async function (val) {
      if (val && this.transactions && this.transactions.length) {
        await this.load()
      }
    },
    'searchProvider.search': debounce(async function (val) {
      if (val.length >= 3) {
        this.searchProvider.isLoading = true
        const params = {
          amount: sumBy(this.transactions, 'amount'),
          restaurant: this.restaurant,
          status: 'pending_payment',
          providerName: `/${val}/i`
        }
        try {
          const res = await this.$api.get(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}`, params)
          this.searchProvider.items = res
          this.tableOrders.data = res.map(order => {
            if (order.invoices && order.invoices.length === 1) {
              if (order.invoices.type === 'N') {
                const invoice = order.invoices
                invoice.source = invoice.receiverTaxName
                invoice.sourceId = invoice.receiverTaxid
                order.invoices = [invoice]
              }
            }
            return order
          })
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.searchProvider.isLoading = false
      } else {
        await this.loadOrders()
      }
    }, 600)
  },
  computed: {
    movementsPermissions () {
      return this.$store.state.login.permissions['expenses'].components['financial-movements'].actions
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data._id
    },
    open: {
      get: function () {
        return this.isOpen
      },
      set: function (newValue) {
        this.$emit('update:isOpen', newValue)
      }
    },
    totalInvoicesAmount: function () {
      return sumBy(this.transactions, 'amount')
    },
    totalMovementsOrdersAmount: function () {
      return sumBy(this.tableOrders.selected, 'total') + sumBy(this.tableMovements.selected, 'amount')
    }
  },
  async mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
    await this.loadCategories()
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') {
        this.resetForm()
        this.$emit('close')
      }
    },
    async relateCategory () {
      const bankTransactions = this.transactions.length !== 0
        ? this.transactions.map(({ _id }) => _id)
        : []

      const payload = {
        bankTransactions,
        updatedBy: this.$store.state.login.user._id,
        restaurant: this.restaurant,
        bank: this.bankId,
        unitAccount: this.accountId || undefined,
        outgoingCategory: this.categoryForm.outgoingCategory
      }

      this.overlay = true
      try {
        await this.$api.post(`/v1/bank-reconciliation`, payload)
        this.closeRelateCategory()
        this.closePanel()
        this.$emit('reset')
        this.$emit('updateTransactions')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    openRelateCategory () {
      this.relateCategoryOpen = true
    },
    closeRelateCategory () {
      this.categoryForm.outgoingCategory = null
      this.relateCategoryOpen = false
    },
    async loadCategories (params = null) {
      params = params || {
        type: 'outgoing',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.categories.loading = true
      try {
        const response = await this.$api.get(`/v1/cashflows`, params)
        this.categories.data = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.categories.loading = false
    },
    openAddPayOrderPanel () {
      this.isAddPayOrderPanelOpen = true
    },
    emitUpdateBankReconciliation () {
      this.closePanel()
      this.$emit('updateTransactions')
    },
    async openDetail (item) {
      if (item) {
        await this.$refs.invoiceViewer.open(item)
      }
    },
    statusNames (status) {
      return {
        created: 'Sin enviar',
        sent: 'Enviada',
        confirmed: 'Confirmada',
        canceled: 'Cancelada',
        invoiced: 'Facturada',
        invalid: 'Factura no coincide',
        invalid_invoice: 'Factura no coincide',
        received: 'Recibida',
        pending_payment: 'Pendiente de pago',
        paid: 'Pagada'
      }[status]
    },
    load: async function () {
      // await this.loadTransfers()
      await this.loadOrders()
    },
    async loadTransfers (params = null) {
      params = params || {
        amount: sumBy(this.transactions, 'amount')
      }
      this.tableMovements.loading = true
      try {
        const response = await this.$api.get(`/v1/transfers`, params)
        this.tableMovements.data = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.tableMovements.loading = false
    },
    async loadOrders (params = null) {
      params = params || {
        amount: sumBy(this.transactions, 'amount'),
        restaurant: this.restaurant,
        status: 'pending_payment'
      }
      this.tableOrders.loading = true
      try {
        const response = await this.$api.get(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}`, params)
        this.tableOrders.data = response.map(order => {
          if (order.invoices && order.invoices.length === 1) {
            if (order.invoices.type === 'N') {
              const invoice = order.invoices
              invoice.source = invoice.receiverTaxName
              invoice.sourceId = invoice.receiverTaxid
              order.invoices = [invoice]
            }
          }
          return order
        })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.tableOrders.loading = false
    },
    relateBankMovement: async function () {
      const orders = this.tableOrders.selected.length !== 0
        ? this.tableOrders.selected.map(({ _id }) => _id)
        : []

      const movements = this.tableMovements.selected.length !== 0
        ? this.tableMovements.selected.map(({ _id }) => _id)
        : []

      const bankTransactions = this.transactions.length !== 0
        ? this.transactions.map(({ _id }) => _id)
        : []

      const payload = {
        bankTransactions,
        orders,
        transfers: movements,
        updatedBy: this.$store.state.login.user._id,
        restaurant: this.restaurant,
        bank: this.bankId,
        // Todo: integrate unitAccount
        unitAccount: this.accountId || undefined
      }

      this.overlay = true
      try {
        await this.$api.post(`/v1/bank-reconciliation`, payload)
        this.closeWarningDialog()
        this.closePanel()
        this.$emit('reset')
        this.$emit('updateTransactions')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    // Todo: delete
    // relateBankMovement: async function () {
    //   let orders = this.tableOrders.selected.length !== 0
    //     ? this.tableOrders.selected.map(({ _id }) => _id)
    //     : []
    //   // eslint-disable-next-line
    //   const movements = this.tableMovements.selected.length !== 0
    //     ? this.tableMovements.selected.map(({ _id }) => _id)
    //     : []

    //   const payload = {
    //     orders,
    //     transfers: movements
    //   }

    //   this.overlay = true
    //   try {
    //     // eslint-disable-next-line
    //     await Promise.all(
    //       this.transactions.map((transaction) =>
    //         this.$api.patch(`/v1/banks/transactions/${transaction._id}`, payload)
    //       ))
    //     this.closePanel()
    //     this.$emit('updateTransactions')
    //   } catch (error) {
    //     this.$toasted.show(error.message, { duration: 3000 })
    //   }
    //   this.overlay = false
    // },
    resetForm () {
      this.tableMovements.data = []
      this.tableOrders.data = []
      this.tableMovements.selected = []
      this.tableOrders.selected = []
    },
    closePanel () {
      this.resetForm()
      this.$emit('close')
    },
    openWarningDialog () {
      this.warningDialogOpen = true
    },
    closeWarningDialog () {
      this.warningDialogOpen = false
    },
    checkAmountsCoincide () {
      const toleranceAmount = 1
      if (this.totalInvoicesAmount <= this.totalMovementsOrdersAmount + toleranceAmount && this.totalInvoicesAmount >= this.totalMovementsOrdersAmount - toleranceAmount) {
        this.relateBankMovement()
      } else {
        this.openWarningDialog()
      }
    },
    resetSelectedTransactions () {
      this.resetForm()
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped>
  .alert-icon {
    font-size: 6.25rem !important;
    color: #DF2D2D !important;
  }

  .dialogText {
    font-size: 1.285rem;
    line-height: 1.25;
    margin-bottom: 0;
    font-size: 1.125rem;
    line-height: 24.24px;
  }

  .invoiceBox {
    padding: 0.875rem 2.313rem;
    background: #F0F0F0;
    border: 1.5px dashed #757575;

    table tr td:last-child {
      padding-left: 3rem;
    }
  }
</style>

<style lang="scss">
  .content {
    overflow: visible;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .titlePanel {
    font-weight: 500;
    font-size: 28px;
    line-height: 33px;
  }

  .subtitle {
    padding-top: 40px;
    padding-bottom: 20px;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #646464;
  }

  .relateTable tr {
    border: 1px solid #ACABAB;
    border-radius: 7px;
  }

  .relateTable td:first-child {
    border-left: 1px solid #ACABAB;
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }

  .relateTable td {
    border-top: 1px solid #ACABAB;
    border-bottom: 1px solid #ACABAB;
  }

  .relateTable td:last-child {
    border-right: 1px solid #ACABAB;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }

  .relateTable thead tr:last-child th {
    border-bottom: none !important;
  }

  .noInfo {
    border: 1px solid #ACABAB;
    border-radius: 7px;
    padding-top: 22px;
    padding-bottom: 22px;
    text-align: center;
    line-height: 19px;
    color: #ACABAB;
  }

  .theme--light.v-icon {
    color: inherit;
  }

  .grow {
    flex-grow: 1
  }

  .buttonContainer {
    margin-top: 20px;
  }

</style>
